import {
    RESET_SKILLS,
    GET_SKILLS,
    SET_SKILLS,
    API_ERROR,
    GET_SKILL,
    SET_SKILL,
  } from "./actionTypes";

  const initialState = {
    errorSkill: false,
    loadingSkill: false,
    dataSkill: null,
    successSkill: false,
  };
  
  const Skill = (state = initialState, action) => {
    switch (action.type) {
      case RESET_SKILLS:
        state = initialState;
        break;
      case GET_SKILLS:
        state = {
          errorSkill: false,
          loadingSkill: true,
          dataSkill: null,
        };
        break;
      case SET_SKILLS:
        state = {
          errorSkill: false,
          loadingSkill: false,
          dataSkill: action.payload,
        };
        break;
      case GET_SKILL:
        state = {
          errorSkill: false,
          loadingSkill: true,
          dataSkill: action.payload,
        };
        break;
      case SET_SKILL:
        state = {
          errorSkill: false,
          loadingSkill: false,
          dataSkill: action.payload,
        };
        break;
      case API_ERROR:
        state = {
          ...state,
          errorSkill: action.payload,
          loadingSkill: false,
          dataSkill: null,
          successSkill: false,
        };
        break;
      default:
        // state = { ...state, errorSkill: false, loadingSkill: false };
        break;
    }
    return state;
  };
  
  export default Skill;
  